export default __webpack_public_path__ + "static/media/create.0fb40a5f.svg";